import { render, staticRenderFns } from "./copyTypeList.vue?vue&type=template&id=73857ac6&scoped=true&"
import script from "./copyTypeList.vue?vue&type=script&lang=js&"
export * from "./copyTypeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73857ac6",
  null
  
)

export default component.exports